import React, { ReactNode } from 'react';
import { DataGridCellBaseProps } from '../../DataGridCell.types';

export type DataGridCustomCellProps = { render: (value: string | number | any, data: any) => ReactNode };
export const DataGridCustomCell: React.FC<
  DataGridCellBaseProps<string, DataGridCustomCellProps>
> = ({ value, cellProps: { render }, data }) => {
  return <>{render(value, data)}</>;
};
